<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page1-bg.jpg">
    <img class="header-phone" src="@/assets/page1-bg-phone.jpg">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <div class="title-bg"></div>
    <div class="title-text">Ninja: Chakra Warriors</div>
    <div class="content">
      <div class="content-wrapper">
        <p>With a variety of maps to explore, a diverse set of missions, and the ability to recruit fellow ninjas, this game is perfect for those who love action-packed adventures.</p>
        <p>1. **FIERY ADVENTURE TO BECOME A TOP NINJA**</p>
        <p>- Embark on a thrilling and fiery adventure to prove your worth and become the ultimate ninja.</p>
        <p>2. **UNLOCK MULTIPLE MAPS**</p>
        <p>- Explore a vast and diverse world filled with unique environments.</p>
        <p>3. **INTENSE BATTLE STYLE**</p>
        <p>- Utilize a wide array of ninja techniques, weapons, and chakra powers to outmaneuver and defeat your enemies in dynamic combat.</p>
        <p>4. **RANDOM MISSIONS ADD FUN**</p>
        <p>- Complete a variety of tasks, from stealth missions to intense team battles, and earn rewards to enhance your ninja abilities.</p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 100px;
    width: 160px;
    height: 160px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    width: 680px;
    height: 254px;
    background: url(../assets/title-bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 220px;
    left: calc(50% - 640px);
  }
  .content{
    position: absolute;
    padding: 36px;
    top: 560px;
    left: calc(50% - 600px);
    width: 1200px;
    height: 680px;
    background: url(../assets/content-bg.png);
    background-size: 100% 100%;
    font-size: 30px;
    .content-wrapper{
      max-height: 660px;
      overflow: auto;
      p{
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .logo{
      top: 20px;
      left: 20px;
      width: 120px;
      height: 120px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 30px;
      font-family: titleFont;
      position: absolute;
      top: 36px;
      left: calc(50% - 170px);
    }
    .content{
      top: 320px;
      padding: 36px;
      left: calc(50% - 278px);
      width: 556px;
      height: 430px;
      max-height: 430px;
      overflow: auto;
      background: url(../assets/content-phone-bg.png);
      background-size: 100% 100%;
      .content-wrapper{
        max-height: 420px;
        overflow: auto;
      }
    }
  }
}
</style>